import sendEvent from '@helpers/tracking';
import { useAddUserEventMutation } from '@hooks/userEvents';
import { withNavigationDelay } from '@helpers/link';

export default function LinkWithTracking({
  href,
  category,
  action,
  name = '',
  children,
  target,
  className
}) {
  const addUserEvent = useAddUserEventMutation();
  const userEventType = `${category}:${action}${name ? `:${name}` : ''}`;

  const handleClick = (e) => {
    sendEvent(category, action, name);

    try {
      Promise.resolve(
        addUserEvent({ variables: { type: userEventType, data: '{}' } })
      ).catch(() => {});
    } catch {}

    if (target !== '_blank') {
      e.preventDefault();

      withNavigationDelay(() => {
        window.location.href = href;
      });
    }
  };

  return (
    <a href={href} target={target} className={className} onClick={handleClick}>
      {children}
    </a>
  );
}
